import * as actionTypes from '../actions/actionTypes';

const initState = {
    viewType: 'list',
    // vehicleType: localStorage.getItem('vehicleType'),
    vehicleType: 'all',
    itemsLoading: false,
    vehicleItems: [],
    currentURL: null,
    error: null,
    commingSoon: false
}

const searchPageViewType = (state, action) => {
    return {
        ...state,
        viewType: action.viewType
    }
};

const searchVehicleType = (state, action) => {
    return {
        ...state,
        vehicleType: action.vehicleType
    }
}

const initGetVehicleItems = (state, action) => {
    return {
        ...state,
        itemsLoading: action.itemsLoading,
        commingSoon: action.commingSoon,
    }
}

const successGetVehicleItems = (state, action) => {
    return {
        ...state,
        itemsLoading: action.itemsLoading,
        vehicleItems: action.vehicleItems,
        currentURL: action.currentURL,
        commingSoon: action.commingSoon,
    }
};

const failGetVehicleItems = (state, action) => {
    return {
        ...state,
        itemsLoading: action.itemsLoading,
        error: action.error,
        commingSoon: action.commingSoon,
    }
};

const commingSoon = (state, action) => {
    return {
        ...state,
        commingSoon: action.commingSoon,
    }
};

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.SEARCH_PAGE_VIEW_TYPE: return searchPageViewType(state, action);
        case actionTypes.SEARCH_VEHICLE_TYPE: return searchVehicleType(state, action);
        case actionTypes.INIT_GET_VEHICLE_ITEMS: return initGetVehicleItems(state, action);
        case actionTypes.SUCCESS_GET_VEHICLE_ITEMS: return successGetVehicleItems(state, action);
        case actionTypes.FAIL_GET_VEHICLE_ITEMS: return failGetVehicleItems(state, action);
        case actionTypes.COMMING_SOON: return commingSoon(state, action);
        default: return state
    }
};

export default reducer;
